<dt-modal-content size="medium" [contentPadding]="false" (closeClick)="close()">
  <ng-template #title i18n>Einladungen</ng-template>
  <ng-template #content>
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="teamName">
        <mat-header-cell *matHeaderCellDef i18n>Projekt Name</mat-header-cell>
        <mat-cell *matCellDef="let invite">
          <span class="text" matTooltip="{{ invite.teamName }}">{{ invite.teamName }}</span></mat-cell
        >
      </ng-container>

      <ng-container matColumnDef="inviterName">
        <mat-header-cell *matHeaderCellDef i18n>Eingeladen von</mat-header-cell>
        <mat-cell *matCellDef="let invite">{{ invite.inviterInfo.name ?? invite.inviterInfo.email }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef i18n>Eingeladen am</mat-header-cell>
        <mat-cell *matCellDef="let invite">{{ invite.invitedAt | date: 'short' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let invite">
          <button
            mat-icon-button
            color="accent"
            (click)="joinTeam(invite.inviteToken)"
            matTooltip="Team beitreten"
            i18n-matTooltip
            matTooltipShowDelay="200"
            i18n
          >
            <mat-icon>check_circle</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            matTooltip="Einladung ablehnen"
            i18n-matTooltip
            matTooltipShowDelay="200"
            (click)="rejectTeam(invite.inviteToken)"
            i18n
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Definitions -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let invite; columns: displayedColumns"></mat-row>

      <div class="no-data" *matNoDataRow>
        <span i18n>Keine Ausstehende Einladungen</span>
      </div>
    </mat-table>
  </ng-template>
</dt-modal-content>
